import { Routes } from '@angular/router';
import { autenticato } from '@shared/guardie/autenticato.guard';
import { CategorieComponent } from '@modules/gestione-articoli/categorie/categorie.component';

export const categorieRoutes: Routes = [
  {
    path: 'gestione-articoli/categorie',
    canActivate: [autenticato],
    component: CategorieComponent,
    data: {
      breadcrumb: {
        label: 'Gestione Categorie',
      },
    },
  }
];
